import { valibotResolver } from "@hookform/resolvers/valibot";
import { Check } from "@phosphor-icons/react";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { Button } from "common/components/ui/Button";
import { Input } from "common/components/ui/Input";
import useWhitelabelMutations from "common/datahooks/useWhitelabelMutations";
import useWhitelabelCustomization from "common/hooks/useWhitelabelCustomization";
import { EmailSchema } from "common/schemas";

export default function Login() {
  const { whitelabelCustomization } = useWhitelabelCustomization();
  const { sendMagicLink, isSendingMagicLink } = useWhitelabelMutations();
  const [sendCount, setSendCount] = useState<number>(0);

  const { register, handleSubmit } = useForm<{
    email: string;
  }>({
    resolver: valibotResolver(EmailSchema),
  });

  function onSubmit({ email }: { email: string }) {
    sendMagicLink({ email, slug: whitelabelCustomization.slug }).then(() => {
      setSendCount((prevCount) => prevCount + 1);
    });
  }

  return (
    <div className="flex flex-col h-dvh bg-no-repeat bg-[length:100%_290px] relative bg-white">
      <img
        className="max-h-20 mt-4 mx-auto"
        alt=""
        src={whitelabelCustomization.logo}
      />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col w-[540px] px-4 py-4 flex-grow justify-center mx-auto"
      >
        <h1 className="text-4xl-bold mb-5 text-center">
          Sign into {whitelabelCustomization.name}
        </h1>
        <p className="text-black-500 mb-6 text-center mx-10">
          Enter your email address below to sign into your account
        </p>
        <Input
          className="mb-6 mx-12"
          aria-label="Email"
          placeholder="Email"
          variant="lg"
          {...register("email")}
        />
        <Button
          type="submit"
          disabled={sendCount > 0}
          isLoading={isSendingMagicLink}
          className="mx-12"
        >
          {sendCount > 0 ? (
            <>
              <span className="text-button-sm">Magic link sent</span>
              <Check size={20} />
            </>
          ) : (
            <span className="text-button-sm">Send magic link</span>
          )}
        </Button>
        {sendCount > 0 && (
          <div className="flex items-center mt-4 justify-center text-xs">
            Didn’t receive the link?{" "}
            <Button
              size="sm"
              variant="link-black"
              type="submit"
              disabled={isSendingMagicLink || sendCount > 1}
            >
              {sendCount === 1 ? "Send again" : "Link sent"}
            </Button>
          </div>
        )}
      </form>
    </div>
  );
}
